module.exports = __webpack_public_path__ + "assets/img/00017.2d8ab869.png";